module.exports = __webpack_public_path__ + "img/person-running.ead98fcc.svg";